
// Extend
import base from '@/scripts/base';

// Api
import api from '@/api/baseApi';
import { API_CALL_STATUS } from "@/constant/baseConstant";
import { SETTINGS_DEVELOPER_API } from "@/constant/apiSettings";

export default {
    extends: base,
    data() {
        return {
            endpoint: 'https://api-m.gpuhub.net',
            isApiEnabled: false,
            token: {
                apiToken: null,
                clientId: null,
                secretKey: null,
            },
            domainOrIpInput: '',
            domainOrIpInputIsValid: true,
            domainOrIpList: [],
            firstLoad: true
        };
    },
    watch: {
        isApiEnabled() {
            this.enabledApi(this.isApiEnabled);
        }
    },
    mounted() {
        this.getApiInfomations();
    },
    methods: {
        validDomainOrIP() {
            if (this.domainOrIpInput === null || this.domainOrIpInput === '') {
                this.domainOrIpInputIsValid = false;
                return false;
            }

            let isValidDomain = /^[a-zA-Z0-9][a-zA-Z0-9-]{1,61}[a-zA-Z0-9](?:\.[a-zA-Z]{2,})+$/.test(this.domainOrIpInput);
            let isValidIP = /^(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/.test(this.domainOrIpInput);
            if (isValidDomain || isValidIP) {
                this.domainOrIpInputIsValid = true;
                return true;
            }
            this.domainOrIpInputIsValid = false;
            return false;
        },
        copyToClipboard(value) {
            const el = $('#apiCopyInput');
            $('#apiCopyInput').val(value);
            $('#apiCopyInput').show();
            el.select();
            el.focus();
            var successful = document.execCommand("copy");
            $('#apiCopyInput').hide();
            this.notificationSuccess(this.$t('api.copiedTitle'), this.$t('api.copiedMessage'));
        },
        getApiInfomations() {
            api.baseRequest(SETTINGS_DEVELOPER_API.GET_API_INFO, null)
                .then((response) => {
                    //console.log('response', response);
                    this.$set(this, 'token', {
                        apiToken: response.data.apiToken,
                        clientId: response.data.clientId,
                        secretKey: response.data.secretKey,
                    });
                    this.$set(this, 'isApiEnabled', response.data.enabled);
                    this.$set(this, 'domainOrIpList', JSON.parse(response.data.restrictions));
                    this.$nextTick(() => {
                        this.firstLoad = false;
                    });
                })
                .catch(error => {
                    this.$nextTick(() => {
                        this.firstLoad = false;
                    });
                    this.processCatchApiRequest(error, this.$t('dialog.requestFailed'))
                });
        },
        enabledApi(isApiEnabled) {
            if (!this.firstLoad) {
                const actionUpdate = () => {
                    let data = {
                        isEnable: isApiEnabled,
                        deviceInformation: JSON.stringify(this.getInformationClient())
                    };
                    api.baseRequest(SETTINGS_DEVELOPER_API.ENABLE_API, data)
                        .then((response) => {
                            this.$set(this, 'token', {
                                apiToken: response.data.apiToken,
                                clientId: response.data.clientId,
                                secretKey: response.data.secretKey,
                            });
                            this.$set(this, 'isApiEnabled', response.data.enabled);
                            this.notificationSuccess(this.$t('dialog.success'), this.$t('api.settingsUpdated'));
                        })
                        .catch(error => {
                            this.processCatchApiRequest(error, this.$t('dialog.requestFailed'))
                        });
                };
                actionUpdate();
            }
        },
        addRestrictions() {
            if (this.validDomainOrIP()) {
                let data = {
                    domainOrIp: this.domainOrIpInput,
                    deviceInformation: JSON.stringify(this.getInformationClient())
                };
                api.baseRequest(SETTINGS_DEVELOPER_API.ADD_RESTRICTIONS, data)
                    .then(() => {
                        this.domainOrIpList.push(this.domainOrIpInput);
                        this.$set(this, 'domainOrIpInput', '');
                        this.$set(this, 'domainOrIpInputIsValid', true);
                        this.notificationSuccess(this.$t('dialog.success'), this.$t('api.settingsUpdated'));
                    })
                    .catch(error => {
                        this.processCatchApiRequest(error, this.$t('dialog.requestFailed'))
                    });
            }
        },
        removeRestrictions(domainOrIp) {
            this.$confirm(this.$t('api.removeConfirmMessage'), this.$t('api.removeConfirmTitle'), {
                confirmButtonText: this.$t('api.ok'),
                cancelButtonText: this.$t('api.cancel'),
                type: 'warning'
            }).then(() => {
                let data = {
                    domainOrIp: domainOrIp,
                    deviceInformation: JSON.stringify(this.getInformationClient())
                };
                api.baseRequest(SETTINGS_DEVELOPER_API.REMOVE_RESTRICTIONS, data)
                    .then(() => {
                        let indexItem = this.domainOrIpList.findIndex(x => x === domainOrIp);
                        this.domainOrIpList.splice(indexItem, 1);
                        this.notificationSuccess(this.$t('dialog.success'), this.$t('api.settingsUpdated'));
                    })
                    .catch(error => {
                        this.processCatchApiRequest(error, this.$t('dialog.requestFailed'))
                    });
            }).catch(() => { });
            
        }
    }
}